import { useRef, useEffect } from 'react';
import gsap from 'gsap';

export const GOLD = '#b89a5e';
export const CHARCOAL = '#1c1a17';

export function useGoldUnderline<T extends HTMLElement>() {
  const elRef = useRef<T>(null);
  const lineRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = elRef.current;
    const line = lineRef.current;
    if (!el || !line) return;

    gsap.set(line, { scaleX: 0, transformOrigin: 'left center' });

    const onEnter = () => {
      gsap.killTweensOf([el, line]);
      gsap.set(line, { transformOrigin: 'left center' });
      gsap.to(el, { color: GOLD, duration: 0.2 });
      gsap.to(line, { scaleX: 1, duration: 0.28, ease: 'power2.out' });
    };
    const onLeave = () => {
      gsap.killTweensOf([el, line]);
      gsap.set(line, { scaleX: 1, transformOrigin: 'right center' });
      gsap.to(el, { color: CHARCOAL, duration: 0.2 });
      gsap.to(line, { scaleX: 0, duration: 0.22, ease: 'power2.in' });
    };

    el.addEventListener('mouseenter', onEnter);
    el.addEventListener('mouseleave', onLeave);
    return () => {
      el.removeEventListener('mouseenter', onEnter);
      el.removeEventListener('mouseleave', onLeave);
    };
  }, []);

  return { elRef, lineRef };
}

export function GoldUnderlineSpan({ lineRef }: { lineRef: React.RefObject<HTMLSpanElement | null> }) {
  return (
    <span
      ref={lineRef}
      aria-hidden
      className="pointer-events-none absolute -bottom-0.5 left-0 h-px w-full"
      style={{ background: GOLD, transform: 'scaleX(0)' }}
    />
  );
}
